import { PayloadAction } from "@reduxjs/toolkit";
import { T_LocalMfBaseData } from "./MF_BaseData_Types";

export const MF_ReduxInitialState = {
  isFetching: false,
  error: undefined,
  success: undefined,
  lastRanApiDetails: undefined,
};
export const MF_HandlingReducerAction = (
  state: T_LocalMfBaseData,
  action: PayloadAction<any, "fetching" | "error" | "success">
) => {
  switch (action.type) {
    case "fetching":
      return { ...state, isFetching: true };
    case "error":
      return {
        ...state,
        error: action.payload as Error,
        success: false,
        isFetching: false,
      };
    case "success":
      return {
        ...state,
        success: true,
        isFetching: false,
        error: undefined,
      };
    default:
      return state;
  }
};
